const TYPE = 'REGISTRATION_SET_PAIRED';

const action = (mac) => (dispatch) => dispatch({ type: TYPE, payload: mac });

export default { action, TYPE };
